import { lazy } from "react";

const Login = lazy(() => import("./Login"));
const Dashboard = lazy(() => import("./Dashboard"));
const Watchlist = lazy(() => import("./Watchlist"));
const Portfolio = lazy(() => import("./Portfolio"));
const OnBoarding = lazy(() => import("./OnBoarding"));
const Orders = lazy(() => import("./Orders"));
const ForgotPassword = lazy(() => import("./ForgotPassword"));
const ForgotUserID = lazy(() => import("./ForgotUserID"));
const ForgetMpin = lazy(() => import("./ForgetMpin"));
const Settings = lazy(() => import("./Setting"));
const RecommendationsAlerts = lazy(() => import("./RecommendationsAlerts"));
const EnvironmentSetting = lazy(() => import("./EnvironmentSetting"));
const Calculator = lazy(() => import("./Calculator"));
const MutualFunds = lazy(() => import("./MutualFunds"));
const Register = lazy(() => import("./Register"));
const OrderCart = lazy(() => import("./OrderCart"));
const Ipo = lazy(() => import("./Ipo")); // BREEZE: 3416 : IPO Responsive UI: ManasaB : 29 - 11 - 2024 : Importing of IPO route 
// Ajitesh : 10/11/2023: BT-109135: Breeze eDIS implementation - Start
const Edis = lazy(() => import("./Edis"));
// Ajitesh : 10/11/2023: BT-109135: Breeze eDIS implementation - End


const AddendumReportsScreen = lazy(() => import("./AddendDumReportsScreen"));



export { AddendumReportsScreen, Dashboard, RecommendationsAlerts, Settings, Login, Watchlist, Portfolio, OnBoarding, Orders, ForgotPassword, ForgotUserID, ForgetMpin, EnvironmentSetting, Calculator, MutualFunds, Register, Edis, OrderCart, Ipo };


